<template>
    <Feedback class="emailVerification"
        v-if="emailVerified === false && auth.id"
        type="warning"
        icon="email"
        :borderless="true">
        <template slot="body">
            <p>{{ siteContent.verifyYourEmail }}</p>
        </template>
        <template slot="actions">
            <Button class="verifyButton"
                appearance="secondary"
                size="small"
                suffixIcon="send"
                iconSize="s"
                @click="sendVerification">
                {{ siteContent.sendVerification }}
            </Button>
        </template>
    </Feedback>
</template>

<script>
    import firebase from 'firebase/app'

    export default {
        name: 'EmailVerification',
        data() {
            return {
                emailVerified: null
            }
        },
        mounted() {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    this.emailVerified = user.emailVerified
                } else {

                }
            })
        },
        methods: {
            sendVerification() {
                firebase.auth().currentUser.sendEmailVerification()
                .then(() => {
                    console.log('sent')
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/variables';

    .verifyButton {
        margin-left: 1rem;
    }

    @media all and (max-width: 480px) {
        .emailVerification {
            flex-direction: column;
        }

        .button {
            margin: 1rem 0 0 0;
            align-self: flex-start;
        }
    }
</style>